module.exports = __webpack_public_path__ + "resources/5de2753b1848fb6afa8f2c1c50cdf247.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/backgroundbribe.png
// module id = 191
// module chunks = 0